export default __webpack_public_path__ + "static/media/647.9f257420.jpg";